export default __webpack_public_path__ + "static/media/CNo.69-2.dc3eb37a.jpg";